(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
        });

        //////////////////////////////////////////////////////////////
        // Menu Hover Dropdown
        //////////////////////////////////////////////////////////////
        $('.js-navbar-nav li.dropdown').hover(function() {
          const obj = $(this);
          const viewportWidth = $(window).width();
          if( viewportWidth > 1199){
            obj.find('.js-dropdown-toggle').addClass('show');
            obj.find('.dropdown-menu').stop(true, true).delay(200).fadeIn(200);
          }
        }, function() {
          const obj = $(this);
          const viewportWidth = $(window).width();
          if( viewportWidth > 1199){
            obj.find('.js-dropdown-toggle').removeClass('show');
            obj.find('.dropdown-menu').stop(true, true).delay(200).fadeOut(200);
          }
        });


        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };



  jQuery(document).on('ready', function () {
    //////////////////////////////////////////////////////////////
    // Recipes Single (Method Tabs)
    //////////////////////////////////////////////////////////////
    // Set default active tab
    jQuery('.js-tab-button').click(function () {
      const $obj = jQuery(this); 
      $_level = $obj.attr('data-level');
      $_prep = $obj.attr('data-prep');
      $_time = $obj.attr('data-time');
      $_serves = $obj.attr('data-serves');
      jQuery('.js-tab-button').removeClass('active');
      jQuery('.js-tab-content').removeClass('active');

      jQuery('.section-flexi-recipe-details-meta-col-level').text($_level);
      jQuery('.section-flexi-recipe-details-meta-col-prep').text($_prep);
      jQuery('.section-flexi-recipe-details-meta-col-time').text($_time);
      jQuery('.section-flexi-recipe-details-meta-col-serves').text($_serves);

      $(this).addClass('active');
      const tabId = jQuery(this).data('tab');
      jQuery('#' + tabId).addClass('active');
    });
    jQuery('.js-tab-button:first').click();

  });
  


  //////////////////////////////////////////////////////////////
  // HOTSPOT - Stockis locations
  //////////////////////////////////////////////////////////////
  jQuery(document).on('click','.js-flexi-hotspot-canvas-pin',function (e) {
      const obj = jQuery(this);
      if( jQuery(e.target).hasClass('js-flexi-hotspot-canvas-pin-text-content-close')){
        obj.closest('.flexi-hotspot-canvas-pin').removeClass('active');
      }else{
        obj.addClass('active').siblings().removeClass('active');
      }
  });





  // GRAVITY FORM
  jQuery('input, textarea').on('input', function() {
    const obj = jQuery(this);
    if (jQuery(this).val()) {
      obj.closest('.ginput_container').prev().addClass('has-value');
      obj.addClass('has-value');

    } else {
      obj.closest('.ginput_container').prev().removeClass('has-value');
      obj.removeClass('has-value');
    }
  });




  //jQuery(document).on('click','.js-flexi-hotspot-canvas-pin-text-content-close',function () {
    //const prn = jQuery(this).closest('.flexi-hotspot-canvas-pin').removeClass('active');
  //});





  // Load Events
  $(document).ready(UTIL.loadEvents);

  //////////////////////////////////////////////////////////////
  // Scrolled nav
  //////////////////////////////////////////////////////////////
  bs_adjust_scroll_nav();
  jQuery(window).scroll(function (event) {
    bs_adjust_scroll_nav();
  });


  //const curpage = jQuery('.archive-template-pagination').attr('data-page');
  //console.log(curpage);
  //loadRecipes( (curpage > 0)? curpage:1 ); // initial load

})(jQuery); // Fully reference jQuery after this point.



jQuery(window).on('load', function() {
  
    //////////////////////////////////////////////////////////////
    // Testimonial Slider
    //////////////////////////////////////////////////////////////
    const carousel = document.querySelector('.js-flickity-testimonials-slider');
    if (carousel !== null) {
      const slides = carousel.querySelectorAll('.js-flexi-testimonials-slider-cell');
      const slideCount = slides.length;
      var flkty = new Flickity('.js-flickity-testimonials-slider', {
        cellAlign: (slideCount > 2)? 'left': 'center',
        contain: true,
        groupCells: false,    
        wrapAround: slideCount > 2,
        pageDots: false,
        draggable: slideCount > 2,
        prevNextButtons: slideCount > 2
      });
      // Custom Buttons
      document.querySelector('.flickity-prev').addEventListener('click', function () {
        flkty.previous();
      });
      document.querySelector('.flickity-next').addEventListener('click', function () {
        flkty.next();
      });
    }



    ////////////////////////////////////////////////////////////////////////////////////
    // Flexible Content: Dynamic Selective Content Module
    ////////////////////////////////////////////////////////////////////////////////////
    flexi_dynamic_selective_content_module();

});


// *******************************
// Logo Slider Init.
// *******************************
document.addEventListener('DOMContentLoaded', function () {
  flexiLogoSliderInit();
  flexiRecipeSliderInit();
});
let resizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function(){
    flexiLogoSliderInit();
    flexiRecipeSliderInit();
  }, 300);
  
});




////////////////////////////////////////////////////////////////////////////////////
// Stockist Search
////////////////////////////////////////////////////////////////////////////////////

jQuery(document).ready(function ($) {

  // Constants ///////////////////////////////////////////////////////////////
  const PER_PAGE = 12;
  const SEARCH_RADIUS_MILES = 5;
  const COUNTRY = 'au';
  
  // Variables ///////////////////////////////////////////////////////////////
  const stockists = stockistData.stockists || [];
  let filteredStockists = [...stockists];

  // Cached Elements /////////////////////////////////////////////////////////
  const $searchInput = $('.js-place-search');
  const $searchWrapper = $searchInput.closest('.flexi-stockist-search-search');
  const $stockistsList = $('.js-stockists-list');
  const $pagination = $('.js-stockists-pagination');

  // Init Google Places //////////////////////////////////////////////////////
  function initGooglePlaces() {

    // Wait for Google ///////////////////////////////////////////////////////
    if (
      typeof google === 'undefined' ||
      typeof google.maps === 'undefined' ||
      typeof google.maps.places === 'undefined'
    ) {
      setTimeout(initGooglePlaces, 200);
      return;
    }

    // Input
    const input = document.querySelector('.js-place-search');
    if (!input) {return;}

    // Autocomplete //////////////////////////////////////////////////////////
    const autocomplete = new google.maps.places.Autocomplete(
      input,
      {
        types: ['(regions)'],
        componentRestrictions: {
          country: COUNTRY
        }
      }
    );

    // Selection /////////////////////////////////////////////////////////////
    autocomplete.addListener('place_changed', function () {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      $searchWrapper.addClass('filled');
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      filterStockists(lat, lng);
    });
  }

  // Start //////////////////////////////////////////////////////////////////
  initGooglePlaces();

  // Initial Load
  renderPage(1);

  // Clear Search
  $searchInput.on('input', function () {
    if ($(this).val().trim()) {return;}
    filteredStockists = [...stockists];
    renderPage(1);
    $searchWrapper.removeClass('filled');
  });

  // View All Stockists //////////////////////////////////////////////////////
  $(document).on('click', '.js-view-all-stockist-locations', function () {
    filteredStockists = [...stockists];
    renderPage(1);
    $searchInput
      .val('')
      .closest('.flexi-stockist-search-search')
      .removeClass('filled');
  });

  // Search Submit ///////////////////////////////////////////////////////////
  $('.js-place-search-submit').on('click', function () {
    const postcode = $searchInput.val().trim();
    if (!postcode) {return;}
    geocodePostcode(postcode);
  });

  // Geocode Postcode ////////////////////////////////////////////////////////
  function geocodePostcode(postcode) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      {
        address: `${postcode}, Australia`
      },
      function (results, status) {
        if (status !== 'OK' || !results.length) {
          alert('Postcode not found');
          return;
        }

        const location = results[0].geometry.location;
        filterStockists(
          location.lat(),
          location.lng()
        );
      }
    );
  }

  // Filter Stockists ////////////////////////////////////////////////////////
  function filterStockists(searchLat, searchLng) {
    filteredStockists = [];
    stockists.forEach(function (stockist) {
      const lat = parseFloat(stockist.lat);
      const lng = parseFloat(stockist.lng);

      // Skip invalid coordinates ///////////////////////////////////////////
      if (isNaN(lat) || isNaN(lng)) {return;}

      const distance = calculateDistanceMiles(
        searchLat,
        searchLng,
        lat,
        lng
      );

      if (distance <= SEARCH_RADIUS_MILES) {
        filteredStockists.push({
          ...stockist,
          distance: distance.toFixed(1)
        });
      }
    });

    // Sort nearest first //////////////////////////////////////////////////////
    filteredStockists.sort(function (a, b) {
      return a.distance - b.distance;
    });

    renderPage(1);
  }

  // Render Page //////////////////////////////////////////////////////////////
  function renderPage(page) {

    const offset = (page - 1) * PER_PAGE;

    const pagedResults = filteredStockists.slice(
      offset,
      offset + PER_PAGE
    );

    let html = '';

    // No Results /////////////////////////////////////////////////////////////
    console.log('Length');
    console.log(pagedResults.length);
    if (!pagedResults.length) {

      html = `
        <span>
          No nearby Stockist found.
          <span class="link-location js-view-all-stockist-locations text-decoration-underline">
            View All Locations
          </span>
        </span>
      `;

      $stockistsList.html(html);
      $pagination.empty();
      return;
    }

    // Results /////////////////////////////////////////////////////////////////
    pagedResults.forEach(function (stockist) {

      const locationParts = [
        stockist.city,
        stockist.state,
        stockist.zip
      ].filter(Boolean);

      const location = locationParts.join(', ');

      html += `
        <a
          href="${escapeHtml(stockist.link)}"
          class="stockist-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h5>${escapeHtml(stockist.title)}</h5>

          ${stockist.name
            ? `<div>${escapeHtml(stockist.name)}</div>`
            : ''}

          ${location
            ? `<div>${escapeHtml(location)}</div>`
            : ''}

          ${typeof stockist.distance !== 'undefined'
            ? `<div>${stockist.distance} miles away</div>`
            : ''}
        </a>
      `;
    });

    $stockistsList.html(html);

    renderPagination(page);
  }

  // Pagination ///////////////////////////////////////////////////////////////
  function renderPagination(currentPage) {

    const totalPages = Math.ceil(filteredStockists.length / PER_PAGE);

    // Hide if only 1 page ////////////////////////////////////////////////////
    if (totalPages <= 1) {
      $pagination.empty();
      return;
    }

    let html = '';

    // Build visible pages /////////////////////////////////////////////////////
    let pages = [];

    // First pages
    pages.push(1, 2);

    ////////////////////////////////////////////////////////////////////////////
    // Middle pages
    ////////////////////////////////////////////////////////////////////////////
    let start = currentPage - 1;
    let end = currentPage + 1;


    // Beginning state /////////////////////////////////////////////////////////
    if (currentPage <= 2) {

      start = 3;
      end = 4;
    }

    // End state ///////////////////////////////////////////////////////////////
    else if (currentPage >= totalPages - 1) {

      start = totalPages - 2;
      end = totalPages - 2;
    }

    // True middle state ///////////////////////////////////////////////////////
    else {

      start = currentPage - 1;
      end = currentPage + 1;
    }

    for (let i = start; i <= end; i++) {

      pages.push(i);
    }

    // Last pages
    pages.push(totalPages - 1, totalPages);


    // Clean pages //////////////////////////////////////////////////////////////
    pages = [...new Set(pages)]
      .filter(function (page) {
        return page >= 1 && page <= totalPages;
      })
      .sort(function (a, b) {

        return a - b;
      });

    // Render pages ////////////////////////////////////////////////////////////
    let prevPage = 0;

    pages.forEach(function (page) {

      // Ellipsis //////////////////////////////////////////////////////////////
      if (page - prevPage > 1) {

        html += `
          <span class="pagination-ellipsis">
            ...
          </span>
        `;
      }

      // Button ///////////////////////////////////////////////////////////////
      html += `
        <button
          class="js-stockist-page ${currentPage == page ? 'active' : ''}"
          data-page="${page}"
          type="button"
        >
          ${page}
        </button>
      `;

      prevPage = page;
    });

    $pagination.html(html);
  }

  // Pagination Click ////////////////////////////////////////////////////////
  $(document).on('click', '.js-stockist-page', function () {
    const page = Number($(this).data('page'));
    renderPage(page);
  });

  // Haversine Formula ///////////////////////////////////////////////////////
  function calculateDistanceMiles(lat1, lon1, lat2, lon2) {
    const EARTH_RADIUS_MILES = 3959;
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    const c = 2 * Math.atan2(
      Math.sqrt(a),
      Math.sqrt(1 - a)
    );
    return EARTH_RADIUS_MILES * c;
  }

  // Degrees to Radians //////////////////////////////////////////////////////
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  // Escape HTML /////////////////////////////////////////////////////////////
  function escapeHtml(str) {
    if (!str) {return '';}
    return $('<div>').text(str).html();
  }

});






